import { render, staticRenderFns } from "./NoCompany.vue?vue&type=template&id=42f35683&scoped=true"
import script from "./NoCompany.vue?vue&type=script&lang=ts"
export * from "./NoCompany.vue?vue&type=script&lang=ts"
import style0 from "./NoCompany.vue?vue&type=style&index=0&id=42f35683&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f35683",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f35683')) {
      api.createRecord('42f35683', component.options)
    } else {
      api.reload('42f35683', component.options)
    }
    module.hot.accept("./NoCompany.vue?vue&type=template&id=42f35683&scoped=true", function () {
      api.rerender('42f35683', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/NoCompany.vue"
export default component.exports